import React, { Fragment, useEffect, useReducer } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Currency } from '../lib/components/Currency';
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { LoadingSpinner } from '../lib/components/LoadingSpinner';
import { FormattedDate } from '../lib/components/FormattedDate';
import { Address } from '../lib/components/Address';
import { withHeaderMessages } from '../higherOrderComponents/WithHeaderMessages';
import { useParams } from 'react-router';
import './clearpoint-reports.css';

const ConfirmationReceiptPurchaserPrint = (props) => {

  const initialState = {
    isLoading: true,
    contract: {
      provider: {
        address: {}
      },
      purchaser: {
        address: {}
      },
      recipients: []
    },
    downPayment: 0,
    downPaymentLoading: true,
    fundingOptions: []
  }
  const reducer = (state, action) => {
    switch (action.type) {
      case 'contractDetails':
        return {
          ...state,
          contract: action.payload,
          isLoading: false
        }
      case 'downPayment':
        console.log(`amount received is ${action.payload}`)
        return {
          ...state,
          downPayment: action.payload,
          downPaymentLoading: false
        }
      case 'fundingOptions':
        return {
          ...state,
          fundingOptions: action.payload,
        }
      case 'isLoading':
        return {
          ...state,
          isLoading: action.payload
        }
      case 'hideLoader':
        return {
          ...state,
          isLoading: false
        }
      default:
        throw new Error();
    }
  }

  const [confirmationReceiptState, dispatch] = useReducer(reducer, initialState);
  const { number } = useParams();


  useEffect(() => {
    props.header.setHeader("confirmationReceiptPrint");
    props.api.get(`/api/contract/${number}`)
      .then(response => {
        if (response.status === 200) {
          return response.data;
        }
      })
      .then(data => {
        dispatch({ type: 'contractDetails', payload: data });
      })
      .catch(hideLoader)
      .then(hideLoader);

    props.api.get(`/api/contract/${number}/down-payment`)
      .then(response => {
        if (response.status === 200) {
          return response.data;
        }
      })
      .then(data => {
        dispatch({ type: 'downPayment', payload: data.totalPayments });
      })
      .catch(hideLoader)
      .then(hideLoader);
  }, [])

  const hideLoader = () => {
    dispatch({ type: 'hideLoader' });
  }

  if (confirmationReceiptState.isLoading || confirmationReceiptState.downPaymentLoading) {
    return <LoadingSpinner />;
  }

  const { contract, downPayment, fundingOptions } = confirmationReceiptState;
  const recipient = contract.recipients.length > 0
    ? contract.recipients[0]
    : {
      firstName: "",
      lastName: "",
      address: {}
    };

  return (
    <Fragment>
      <Row style={{ height: "1in" }}>
        <Col xs={12}>
          &nbsp;
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <Row className="confirmation-row">
            <Col>
              <label>Funeral Purchaser:</label>
              <div>
                {contract.purchaser.firstName} {contract.purchaser.lastName}<br />
                <Address address={contract.purchaser.address} />
              </div>
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Funeral Recipient:</label>
              <div>
                {recipient.firstName} {recipient.lastName}<br />
                <Address address={recipient.address} />
              </div>
            </Col>
          </Row>
          <Row className="confirmation-row">
            <Col>
              <label>Funeral Provider:</label>
              <div>
                {contract.provider.name}<br />
                <Address address={contract.provider.address} />
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={6}>
          <Row className="confirmation-row2" style={{ marginTop: ".25in" }}>
            <Col>
              <label>Agreement Number:</label> {contract.number}
            </Col>
          </Row>
          <Row className="confirmation-row-col2">
            <Col>
              <label>Customer Ref Number:</label> {contract.providerNumber}
            </Col>
          </Row>
          <Row className="confirmation-row-col2">
            <Col>
              {console.log(confirmationReceiptState)}
              <label>Amount Received:</label> <Currency amount={downPayment} />
            </Col>
          </Row>
          <Row className="confirmation-row-col2">
            <Col>
              <label>Date Accepted:</label> <FormattedDate date={contract.accepted} format="MMMM D, YYYY" />
            </Col>
          </Row>
          <Row className="confirmation-row-col2">
            <Col>
              <label>Payment Plan:</label> {(contract.numberOfPayments || 0) > 0 ? "Multipay" : "Single Pay"}
            </Col>
          </Row>
          <Row className="confirmation-row-col2">
            <Col>
              <label>Funding Option(s):</label>
              {fundingOptions.map((f, i) =>
                <div key={i}>{f}<br /></div>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row style={{ marginTop: ".5in" }}>
        <Col xs={12}>
          <Row className="confirmation-row">
            <p>
              This document is intended as a convenience to our customers and is not to be construed as a part of the trust contract. If this information differs in any way from the Funeral Planning Trust Agreement or Trust Funding Option Form, please call us immediately at 1-800-763-0234.
            </p>
          </Row>
        </Col>
      </Row>
    </Fragment>
  );
}

export default withHeaderMessages(WithApiAccess(ConfirmationReceiptPurchaserPrint));
